import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { MatDialog, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { SplashDialogComponent, _SplashOptions } from './splash.component';

export { _SplashOptions as SplashOptions };

@Injectable()
export class SplashService {
    private openHandle: MatDialogRef<SplashDialogComponent>;

    constructor(private dialog: MatDialog, private snackbar: MatSnackBar) {}

    DisplaySplash(options?: _SplashOptions): Observable<any> {
        this.openHandle = this.dialog.open<SplashDialogComponent>(SplashDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Please wait',
                MessageText: 'Loading...',
                ShowProgressBar: true,
                ...options,
            },
        });

        return this.openHandle.afterOpen();
    }

    CloseSplash() {
        if (this.openHandle) {
            this.openHandle.close();
            this.openHandle = null;
        }
    }

    SnackbarAlert(message: string, duration?: number) {
        const config: MatSnackBarConfig = {
            extraClasses: ['alert'],
        };

        config.duration = duration != null ? duration : 3500;

        return this.snackbar.open(message, null, config);
    }

    SnackbarSuccess(message: string, duration?: number) {
        const config: MatSnackBarConfig = {
            extraClasses: ['success'],
        };

        config.duration = duration || 3500;

        return this.snackbar.open(message, null, config);
    }

    SnackbarError(message: string, duration?: number, hold?: boolean) {
        const config: MatSnackBarConfig = {
            extraClasses: ['error'],
        };

        let action: string = null;

        if (duration != null) {
            config.duration = duration;
        }

        if (hold === true) {
            action = 'OK';
            config.duration = 5 * 60 * 1000; // 5 minutes?
        }

        return this.snackbar.open(message, action, config);
    }
}



// WEBPACK FOOTER //
// ./src/services/splash/splash.service.ts